/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PRISON_LABORERS_HAVE_NOT_FREELY_AND_FORMALLY_CONSENTED_TO_PERFO',
              'THE_FACILITY_DOES_NOT_TREAT_PRISON_LABORERS_AND_NON_PRISON_WORK',
              'THERE_IS_NO_SUPERVISION_AND_CONTROL_BY_A_PUBLIC_AUTHORITY',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_follow_any_of_the_following_practices_concerning_p: valueSchema,
  },
}
